import { render, staticRenderFns } from "./CleanUpTwilio.vue?vue&type=template&id=46d83d4e&scoped=true&"
import script from "./CleanUpTwilio.vue?vue&type=script&lang=js&"
export * from "./CleanUpTwilio.vue?vue&type=script&lang=js&"
import style0 from "./CleanUpTwilio.vue?vue&type=style&index=0&id=46d83d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d83d4e",
  null
  
)

export default component.exports